import { Column, Entity, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { MessageSegmentEntity } from './message-segment.entity';
import { SegmentStaticEntity } from './segment-static.entity';

@Entity('_segment')
export class SegmentEntity extends BaseEntity {
	@Column('varchar', { name: '_name', nullable: true, length: 255 })
	public name!: string | null;

	@Column('text', { name: '_query', nullable: true })
	public query!: string | null;

	@Column('text', { name: '_queryFieldsMap', nullable: true })
	public queryFieldsMap!: string | null;

	@Column('tinyint', { name: '_static', nullable: true, width: 1 })
	public static!: boolean | null;

	@Column('varchar', { name: '_type', length: 255 })
	public type!: string;

	@Column('int', { name: '_fk__object__id', unsigned: true })
	public fkObjectId!: number;

	@Column('text', { name: '_displayFields', nullable: true })
	public displayFields!: string | null;

	@Column('text', { name: 'displayQuery' })
	public displayQuery!: string;

	@OneToMany(
		() => MessageSegmentEntity,
		(messageSegment) => messageSegment.fkSegment,
		{},
	)
	public messageSegments!: Array<MessageSegmentEntity>;

	@OneToMany(
		() => SegmentStaticEntity,
		(segmentStatic) => segmentStatic.fkSegment,
		{},
	)
	public segmentStatics!: Array<SegmentStaticEntity>;
}
